export const downloadPdf = (title: string, path: string) => {
  const a = document.createElement('a');

  a.href = path;
  a.download = `${title}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
